import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CropWisePrePostSowing from "../components/CropWisePrePostSowing";
import Breadcrumb from "../components/Breadcrumb";


const CropWisePrePostSowingPage = () => {
  return (
    <>
      {/* <MasterLayout> */}
        <Breadcrumb title="Crop Wise Pre-Post Sowing" />
        <CropWisePrePostSowing />

      {/* </MasterLayout> */}
    </>
  );
};

export default CropWisePrePostSowingPage;
